import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { WINDOW } from '@inshared/shared/util';
import { MotorVehiclesToReplace } from '@app/salesfunnel/interfaces';
import { PolicyProductIdEnum, PurchasedProductInterface } from 'outshared-lib';
import { Subscription } from 'rxjs';
import { ReplacementSalesfunnelService } from './replacement-salesfunnel.service';
import { LocalStorageService } from '@inshared/shared/util-storage';

const LOCALSTORAGE_REPLACE_KEY = 'ls.data:vervangen';
const Actions = {
    REPLACE: 'replace',
    EXTRA: 'extra',
};

@Component({
    selector: 'ins-replacement-salesfunnel',
    templateUrl: './replacement-salesfunnel.modal.html',
    styleUrls: ['./replacement-salesfunnel.modal.scss'],
})
export class ReplacementSalesfunnelModal implements OnInit, OnDestroy {

    public form: UntypedFormGroup;
    public pending: boolean = false;
    public purchasedProduct: PurchasedProductInterface;
    public products: MotorVehiclesToReplace;
    public meldingen: any;
    public vehicleType: string;

    private subscriptions = new Subscription();

    constructor(
        private service: ReplacementSalesfunnelService,
        @Inject(WINDOW) private window: Window,
        @Inject(LocalStorageService) private localStorage: Storage,
    ) {}

    get replacementChoice(): AbstractControl {
        return this.form.get('replacement_choice');
    }

    get newVehicle(): AbstractControl {
        return this.form.get('new_vehicle');
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    public ngOnInit(): void {
        this.createForm();

        if (this.purchasedProduct?.productId === PolicyProductIdEnum.Car) {
            this.vehicleType = 'auto';
        } else if (this.purchasedProduct?.productId === PolicyProductIdEnum.Motorcycle) {
            this.vehicleType = 'motor';
        }
        const replacementVehiclesSubscription = this.service
            .getReplacementVehicles$(this.purchasedProduct?.productId)
            .subscribe((products: MotorVehiclesToReplace) => {
                this.products = products;
                if (!this.products.purchased_product_replacement?.length) {
                    this.window.location.href = '/autoverzekering/berekenen-autoverzekering';
                }
            }, (error) => {
                this.meldingen = error.messages;
            });
        this.subscriptions.add(replacementVehiclesSubscription);
    }

    public onSubmit(): void {
        this.meldingen = null;

        if (!this.form.valid) {
            return;
        }

        if (this.newVehicle.value === Actions.REPLACE) {
            const vehicleToReplace = this.products.purchased_product_replacement.find(
                (vehicle) => vehicle.purchased_product_sequence_number === this.replacementChoice.value,
            );

            this.localStorage.removeItem(LOCALSTORAGE_REPLACE_KEY);

            vehicleToReplace.product_id = this.purchasedProduct?.productId;

            if (vehicleToReplace) {
                this.localStorage.setItem(LOCALSTORAGE_REPLACE_KEY, JSON.stringify(vehicleToReplace));
            }

            this.window.location.href = `autoverzekering/berekenen-autoverzekering?replace=true&purchased_product_sequence_number=${this.replacementChoice.value}`;
        }
        if (this.newVehicle.value === Actions.EXTRA) {
            this.window.location.href = '/autoverzekering/berekenen-autoverzekering';
        }
    }

    public selectOption(value: any): void {
        this.newVehicle.setValue(Actions.REPLACE);
        this.replacementChoice.setValue(value);
    }

    private createForm(): void {
        this.form = new UntypedFormGroup({
            new_vehicle: new UntypedFormControl('', Validators.required),
            replacement_choice: new UntypedFormControl(''),
        });

        const subscriptionRef = this.newVehicle.valueChanges
            .subscribe((option) => {
                    if (option === Actions.REPLACE) {
                        this.replacementChoice.setValue(
                            this.products.purchased_product_replacement[0].purchased_product_sequence_number,
                        );
                    } else {
                        this.replacementChoice.setValue('');
                    }
                },
            );
        this.subscriptions.add(subscriptionRef);
    }
}
